import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { useDispatch, useSelector } from "react-redux";
import { onDisplayedInEdit } from "./VendorServiceSlice";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import { toast } from "react-toastify";
import { KendoLoader } from "../../Kendo/kendo_loader";
export const VendorServices = () => {
  const [VendorServices, setVendorServices] = useState({
    vendorServicesID: 0,
    ServiceType: "",
    DisplayedInID: "",
    displayedInName: "",
    Description: "",
    Image: "",
    OldimagePath: "",
    SortOrder: 0,
  });
  const [Guideline, setGuideline] = useState({
    VendorTypeID: 0,
    guidelineID: 0,
    youtubeLink: "",
    guidelineFile: "",
    FileName: "",
    oldFilePath: "",
    status: "Active",
  });
  const [ValidFeild, setValidFeild] = useState({
    vguidelineFile: false,
    vyoutubeLink: false,
  });
  const [refreshflag, setrefreshflag] = useState(0);
  const [editVisible, setEditVisible] = useState(false);

  const [GuidelineeditVisible, setGuidelineeditVisible] = useState(false);
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const GuidelinemodalRef = useRef(null);
  const { selDisplayedInIds } = useSelector((state) => state.VendorServices);
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [VendorGridList, setVendorGridList] = useState([]);
  const [VTDup, setVTDup] = useState(false);

  const Parentscolumns = [
    {
      field: "vendorServicesID",
      filterable: false,
      hidden: true,
    },
    { field: "sortOrder", hidden: true },
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },

    {
      field: "serviceType",
      title: "Vendor Type",
      width: 150,
    },

    {
      field: "displayedInName",
      title: "Displayed In",
      width: 150,
    },
  ];

  const childColumn = [
    {
      field: "guidelineID",
      hidden: true,
    },
    {
      field: "vendorTypeID",
      hidden: true,
    },
    {
      field: "fileName",
      hidden: true,
    },
    {
      field: "youtubeLink",
      title: "Youtube Link",
      width: 50,
    },
    {
      template: function (e) {
        if (e.oldFilePath) {
          return `<a href="${e.oldFilePath}" target="_blank">${
            e.fileName ?? "File"
          }</a>`;
        }
        return "";
      },
      title: "Guideline File",
      width: 50,
    },
    {
      field: "status",
      title: "Status",
      width: 50,
      template: function (e) {
        return `
          <label class="switch">
            <input 
              type="checkbox" 
              ${e.status === "Active" ? "checked" : ""} 
              data-id="${e.guidelineID}"
              class="status-toggle"
            />
            <span class="slider round"></span>
          </label>`;
      },
    },
  ];

  const handleToggleClick = async (id, newStatus) => {
    await corefetch(
      `PreferedVendors/UpdateGuidelineStaus?GuidelineID=${id}&Status=${newStatus}&ModifiedBy=${sessionUser()}`,
      true,
      false,
      false,
      true
    );
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.classList.contains("status-toggle")) {
        const id = event.target.getAttribute("data-id");
        const newStatus = event.target.checked ? "Active" : "InActive";
        handleToggleClick(id, newStatus);
      }
    };

    // Add event listener
    document.addEventListener("click", handleDocumentClick);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = VendorServices.Image?.size > maxSizeInBytes;

    const err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize && !VTDup) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      const formData = new FormData();
      var data = GetFormData(e);
      if (editVisible && editVisible.visible) {
        data.CultureId = editVisible.cultureId;
      }
      formData.append("vendorServicesID", VendorServices.vendorServicesID);
      formData.append("Servicetype", VendorServices.ServiceType);
      formData.append("DisplayedInID", VendorServices.DisplayedInID);
      formData.append("Description", VendorServices.Description);
      formData.append("OldimagePath", VendorServices.OldimagePath);
      formData.append("SavedBy", sessionUser());
      if (VendorServices.Image) {
        formData.append("Image", VendorServices.Image);
      }

      try {
        await corepost(
          "PreferedVendors/InsertUpdatePreferedVendors",
          formData,
          true,
          true,
          false,
          false
        );
        fetchData();
        setrefreshflag(refreshflag + 1);
        clearForm();
        $("#VendorServices-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onGuidelineSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!ValidFeild.vyoutubeLink && !ValidFeild.vguidelineFile) {
      setLoading(true);
      const formData = new FormData();
      formData.append("VendorTypeID", Guideline.VendorTypeID);
      formData.append("guidelineID", Guideline.guidelineID);
      formData.append("youtubeLink", Guideline.youtubeLink);
      formData.append("oldFilePath", Guideline.oldFilePath);
      formData.append("FileName", Guideline.FileName);
      formData.append("status", Guideline.status);
      formData.append("SavedBy", sessionUser());
      if (Guideline.FileName && Guideline.FileName[0]) {
        formData.append("GuidelineFile", Guideline.FileName[0]);
      }

      try {
        await corepost(
          "PreferedVendors/InsertUpdateGuideline",
          formData,
          true,
          true,
          false,
          false
        );
        setLoading(false);
        const modalElement = document.getElementById("add_Guideline");
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
        refreshChildGrd();
        clearGuidelineForm();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onParentEditClick = async (e) => {
    let temp = VendorServices;
    dispatch(onDisplayedInEdit(e.displayedInID));
    VendorServices.vendorServicesID = e.vendorServicesID;
    VendorServices.ServiceType = e.serviceType;
    VendorServices.DisplayedInID = e.displayedInID;
    VendorServices.Description = e.description;
    VendorServices.Image = e.imagePath;
    VendorServices.OldimagePath = e.imagePath;
    setVendorServices(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(
      document.getElementById("add_VendorServices")
    );
    modal.show();
  };

  const onGuidelineAdd = async (e) => {
    setGuideline((prev) => ({
      ...prev,
      VendorTypeID: e.vendorServicesID,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const onGuidelineEdit = async (e) => {
    setGuidelineeditVisible(true);
    setGuideline((prev) => ({
      ...prev,
      VendorTypeID: e.parent.vendorServicesID,
      guidelineID: e.child.guidelineID,
      FileName: e.child.fileName,
      youtubeLink: e.child.youtubeLink,
      oldFilePath: e.child.oldFilePath,
      status: e.child.status,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const handlePatentDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `PreferedVendors/DeletePreferedVendors?preferedVendorId=${
          e.vendorServicesID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        fetchData();
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const handleChildDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `PreferedVendors/DeleteVendorGiudeline?GiudelineID=${
          e.guidelineID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        refreshChildGrd();
      });
    };
    confirmDelete(onDelete);
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onRowReorderChange = async (List) => {
    try {
      let vendorServicesID = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `PreferedVendors/SortPreferedVendors?TypeId=${vendorServicesID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      setrefreshflag(refreshflag + 1);
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setVendorServices((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        setVendorServices((prev) => ({
          ...prev,
          Image: file,
        }));
        // e.target.value = "";
      } else {
        let temp = VendorServices;
        temp.Image = file;
        setVendorServices(temp);
        document.getElementById("image-name").value = file;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setVendorServices((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const handleDropdownChange = (e) => {
    const seletedValue = e ? e : null;
    setVendorServices((prevEvents) => ({
      ...prevEvents,
      DisplayedInID: seletedValue,
    }));
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setVendorServices({
      vendorServicesID: 0,
      ServiceType: "",
      DisplayedInID: "",
      displayedInName: "",
      Description: "",
      Image: "",
      OldimagePath: "",
      SortOrder: 0,
    });
    setError({});
    setVTDup(false);
    dispatch(onDisplayedInEdit(""));
    setEditVisible(false);
    dispatch(onDisplayedInEdit(""));

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };

  const clearGuidelineForm = () => {
    $("#Guideline-cancel").click();
    setValidFeild((prev) => ({
      ...prev,
      vyoutubeLink: false,
      vguidelineFile: false,
    }));
    setGuideline({
      guidelineID: 0,
      youtubeLink: "",
      guidelineFile: "",
      oldFilePath: "",
      status: "Active",
    });
    $("#GFile").val("");
    setError({});
    setGuidelineeditVisible(false);

    const form = document.getElementById("Guideline-form");
    if (form) {
      form.reset();
    }
  };

  const handleGuidelineFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length == 0) {
      setError({ ValidFile: "Guideline File is required." });
      setValidFeild((prev) => ({
        ...prev,
        vguidelineFile: true,
      }));
      return;
    }
    const validFiles = files.filter((file) =>
      [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setError({ ValidFile: "Files must be valid Word or PDF documents." });
      setValidFeild((prev) => ({
        ...prev,
        vguidelineFile: true,
      }));
      // setGuideline((prev) => ({
      //   ...prev,
      //   FileName: files,
      // }));
      return;
    }

    const maxFileSize = 30 * 1024 * 1024;
    const oversizedFiles = validFiles.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      toast.error("File size must not exceed 30 MB.");
      setError((prev) => ({
        ...prev,
        ValidFile: "",
      }));
      setValidFeild((prev) => ({
        ...prev,
        vguidelineFile: true,
      }));
      $("#GFile").val("");
      return;
    }
    setValidFeild((prev) => ({
      ...prev,
      vguidelineFile: false,
    }));
    setError((prev) => ({
      ...prev,
      ValidFile: "",
    }));
    setGuideline((prev) => ({
      ...prev,
      FileName: files,
    }));
    onValidation("FileName", event.target.value);
  };

  const refreshChildGrd = () => {
    $(`#reload-BannerTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("PreferedVendors/GetVendorsDetails");
      setVendorGridList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Vendor Types</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Vendor Types</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_VendorServices"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <KendoTreeTable
                name={"BannerTreetable"}
                parentTableUrl={
                  CorebaseURL + "PreferedVendors/GetVendorsDetails"
                }
                parentTableColumns={Parentscolumns}
                childTableUrl={
                  CorebaseURL +
                  "PreferedVendors/GetVendorGiudeline?VendorTypeId={vendorServicesID}"
                }
                childTableColumns={childColumn}
                showParentOptions={true}
                showParentAdd={true}
                showParentEdit={true}
                showParentDelete={true}
                onParentAddClick={onParentEditClick}
                onParentEditClick={onGuidelineAdd}
                onParentDeleteClick={handlePatentDeleteClick}
                showChildOptions={true}
                showChildDelete={true}
                onChildEditClick={onGuidelineEdit}
                onChildDeleteClick={handleChildDeleteClick}
                refreshWhen={refreshflag}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add VendorServices Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_VendorServices"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered VendorServices"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={VendorServices.vendorServicesID || 0}
                />

                {/* Single Column Layout */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Vendor Type <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Vendor Type with a maximum length of 40 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={40}
                        className="form-control field"
                        name="ServiceType"
                        value={VendorServices.ServiceType || ""}
                        placeholder="Vendor Type"
                        data-required="true"
                        onChange={(e) => {
                          setVendorServices((prev) => ({
                            ...prev,
                            ServiceType: e.target.value,
                          }));
                          onValidation("ServiceType", e.target.value);
                          let dup;
                          if (VendorServices.vendorServicesID > 0) {
                            const matchingItem = VendorGridList.find(
                              (item) =>
                                item.serviceType.trim().toLowerCase() ==
                                  e.target.value.trim().toLowerCase() &&
                                item.vendorServicesID !=
                                  VendorServices.vendorServicesID
                            );

                            dup = matchingItem;
                            setVTDup(dup);
                          } else {
                            const matchingItem = VendorGridList.find(
                              (item) =>
                                item.serviceType.trim().toLowerCase() ==
                                e.target.value.trim().toLowerCase()
                            );
                            dup = matchingItem;
                            setVTDup(dup);
                          }
                        }}
                      />
                      {error.ServiceType && (
                        <ErrorMsg text="Vendor Type is required." />
                      )}
                      {VTDup && (
                        <ErrorMsg text="Vendor Type is already exist and mapped." />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Displayed In <span className="text-danger">*</span>
                      </label>
                      <KendoMultiSelect
                        name="DisplayedInID"
                        url={CorebaseURL + "Services/GetDisplayesInList"}
                        placeholder={"Select Displayed In..."}
                        dataTextField="eventName"
                        dataValueField="displayedInID"
                        value={selDisplayedInIds}
                        required={true}
                        onValidate={onValidation}
                        onChange={handleDropdownChange}
                        tagMode="multiple"
                      />
                      {error.DisplayedInID && (
                        <ErrorMsg text="Displayed In is required" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Description <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a description with a maximum length of 1000 characters." />
                      </label>
                      <textarea
                        maxLength={1000}
                        className="form-control field"
                        name="Description"
                        value={VendorServices.Description}
                        placeholder="Description"
                        data-required="true"
                        onChange={(e) => {
                          setVendorServices((prev) => ({
                            ...prev,
                            Description: e.target.value,
                          }));
                          onValidation("Description", e.target.value);
                        }}
                      />
                      {error.Description && (
                        <ErrorMsg text="Description is required" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Upload Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly upload an Image within 500KB size.;
                        Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      {error.Image && <ErrorMsg text=" Image is required" />}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {error.InValidFileSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    {VendorServices.OldimagePath &&
                      VendorServices.vendorServicesID > 0 && (
                        <div
                          style={{
                            width: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <a
                            href={`${ImageURL}${VendorServices.OldimagePath}`}
                            target="_blank"
                            style={{
                              textDecoration: "underline",
                              fontSize: "13px",
                            }}
                          >
                            {VendorServices.OldimagePath.split("/").pop()}
                          </a>
                        </div>
                      )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={VendorServices.Image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={VendorServices.OldimagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="VendorServices-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    {/* <Button name={"Save"} /> */}
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add VendorServices Modal --> */}

      {/* <!-- Add Guideline Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_Guideline"
        role="dialog"
        ref={GuidelinemodalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered vendorguidline"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {GuidelineeditVisible ? "Edit Guideline" : "Add Guideline"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearGuidelineForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="Guideline-subForm" onSubmit={onGuidelineSubmit}>
                <input
                  type="hidden"
                  name="bannerID"
                  value={Guideline.guidelineID}
                />
                <input type="hidden" name="status" value={Guideline.status} />

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Youtube Link</label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="youtubeLink"
                      value={Guideline.youtubeLink}
                      placeholder="Youtube Link"
                      // data-required="true"
                      onChange={(e) => {
                        // onValidation("youtubeLink", e.target.value);
                        setGuideline((prev) => ({
                          ...prev,
                          youtubeLink: e.target.value.trim(),
                        }));
                        const youtubeUrlRegex =
                          /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?(\S*&)?)?v=[a-zA-Z0-9_-]{11}(&\S*)?$/;
                        const isUrlValid =
                          !youtubeUrlRegex.test(e.target.value) &&
                          e.target.value.trim();
                        setValidFeild((prev) => ({
                          ...prev,
                          vyoutubeLink: isUrlValid,
                        }));
                      }}
                    />
                    {error.youtubeLink && (
                      <ErrorMsg text="Youtube Link is required" />
                    )}
                    {ValidFeild.vyoutubeLink && (
                      <ErrorMsg text="Youtube Link is not valid" />
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Guideline File</label>{" "}
                    <span className="text-danger">*</span>
                    <InfoIcon
                      content="Please upload Word or PDF files one at a time with a maximum size of
                              30MB."
                    />
                    <input
                      type="file"
                      id="GFile"
                      className="form-control"
                      name="GFileName"
                      accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      onChange={handleGuidelineFileChange}
                    />
                    {error.FileName && (
                      <ErrorMsg text="Guideline File is required" />
                    )}
                    {error.ValidFile && (
                      <div className="text-danger">{error.ValidFile}</div>
                    )}
                    {Guideline.oldFilePath && Guideline.guidelineID > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${Guideline.oldFilePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {/* {Aboutus.OldimagePath.split("/").pop()} */}
                          {
                            decodeURIComponent(Guideline.oldFilePath)
                              .split("/")
                              .pop()
                              .split("?")[0]
                          }
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="FileName"
                      id="image-name"
                      data-required="true"
                      value={Guideline.FileName || ""}
                    />
                    <input
                      type="hidden"
                      name="oldFilePath"
                      value={Guideline.oldFilePath}
                    />
                  </div>
                </div>

                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Guideline-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearGuidelineForm();
                      }}
                    />
                    <Button name={GuidelineeditVisible ? "Update" : "Save"} />
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Guideline Modal --> */}
    </>
  );
};
